import React, { useState } from 'react';
import { MapPin, Paperclip, Plus, Trash2 } from 'lucide-react';
import { DetailCard, DetailSection } from '../../../../../components/shared/DetailPanel/DetailBlocks';
import { MasterAddress } from './financeMasters';
import './FinanceMasters.css';

interface AttachmentsFormSectionProps {
  title: string;
  attachments: string[];
  onChange: (attachments: string[]) => void;
}

// Adjuntos en el formulario
export const AttachmentsFormSection = ({ title, attachments, onChange }: AttachmentsFormSectionProps) => {
  const [newAttachment, setNewAttachment] = useState('');

  const handleAdd = () => {
    const name = newAttachment.trim();
    if (!name) return;
    onChange([...attachments, name]);
    setNewAttachment('');
  };

  return (
    <DetailSection title={title} icon={Paperclip}>
      {attachments.length > 0 && (
        <div className="fin-master__attachments">
          {attachments.map((file, idx) => (
            <div key={`${file}-${idx}`} className="fin-master__attachment">
              <span>{file}</span>
              <button
                type="button"
                className="fin-master__attachment-remove"
                title="Quitar"
                onClick={() => onChange(attachments.filter((_, i) => i !== idx))}
              >
                <Trash2 size={12} />
              </button>
            </div>
          ))}
        </div>
      )}
      <div className="fin-master__attachment-add">
        <input
          type="text"
          value={newAttachment}
          onChange={(e) => setNewAttachment(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAdd();
            }
          }}
          placeholder="Nombre del archivo (ej. CIF_2026.pdf)..."
          className="sidebar-form-input"
        />
        <button type="button" className="module-create-btn" onClick={handleAdd}>
          <Plus size={12} /> Añadir
        </button>
      </div>
    </DetailSection>
  );
};

// Adjuntos en la ficha
export const AttachmentsCard = ({ attachments }: { attachments: string[] }) => (
  <DetailCard icon={Paperclip} title={`Documentos_Adjuntos (${attachments.length})`}>
    {attachments.length === 0 ? (
      <div className="fin-master__empty">Sin documentos adjuntos</div>
    ) : (
      <div className="fin-master__attachments">
        {attachments.map((file, idx) => (
          <div key={`${file}-${idx}`} className="fin-master__attachment">
            <span>{file}</span>
          </div>
        ))}
      </div>
    )}
  </DetailCard>
);

interface AddressFormSectionProps {
  title: string;
  address: MasterAddress;
  onChange: (field: keyof MasterAddress, value: string) => void;
  streetLabel?: string;
  streetPlaceholder?: string;
  cityPlaceholder?: string;
  postalCodePlaceholder?: string;
}

// Dirección fiscal en el formulario
export const AddressFormSection = ({
  title,
  address,
  onChange,
  streetLabel = 'Calle y Número',
  streetPlaceholder = 'Calle Mayor 4, Planta 1',
  cityPlaceholder = 'Madrid',
  postalCodePlaceholder = '28013'
}: AddressFormSectionProps) => (
  <DetailSection title={title} icon={MapPin}>
    <div className="sidebar-form-group">
      <label className="sidebar-form-label">{streetLabel}</label>
      <input
        type="text"
        value={address.street}
        onChange={(e) => onChange('street', e.target.value)}
        placeholder={streetPlaceholder}
        className="sidebar-form-input"
      />
    </div>
    <div className="sidebar-form-grid-2">
      <div className="sidebar-form-group">
        <label className="sidebar-form-label">Ciudad</label>
        <input
          type="text"
          value={address.city}
          onChange={(e) => onChange('city', e.target.value)}
          placeholder={cityPlaceholder}
          className="sidebar-form-input"
        />
      </div>
      <div className="sidebar-form-group">
        <label className="sidebar-form-label">Código Postal</label>
        <input
          type="text"
          value={address.postalCode}
          onChange={(e) => onChange('postalCode', e.target.value)}
          placeholder={postalCodePlaceholder}
          className="sidebar-form-input"
        />
      </div>
    </div>
    <div className="sidebar-form-grid-2">
      <div className="sidebar-form-group">
        <label className="sidebar-form-label">Provincia</label>
        <input
          type="text"
          value={address.province}
          onChange={(e) => onChange('province', e.target.value)}
          placeholder="Madrid"
          className="sidebar-form-input"
        />
      </div>
      <div className="sidebar-form-group">
        <label className="sidebar-form-label">País</label>
        <input
          type="text"
          value={address.country}
          onChange={(e) => onChange('country', e.target.value)}
          placeholder="España"
          className="sidebar-form-input"
        />
      </div>
    </div>
  </DetailSection>
);
